import React from 'react';
import { StepIconProps } from '@mui/material/StepIcon';
import { Box } from '@mui/material';

const StepperIcon: React.FC<StepIconProps> = ({ active, icon }) => {
  return (
    <Box
      sx={{
        color: active ? 'primary.main' : 'grey.700',
        width: 30,
        height: 30,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        border: '1px solid',
        borderColor: 'border.primary',
          '&::after': {
          content: '""',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 20,
          height: 20,
          backgroundColor: 'white',
          borderRadius: '50%',
          zIndex: -1,
        },
      }}
    >
      {icon}
    </Box>
  );
};

export default StepperIcon;